import { render, staticRenderFns } from "./ISFDetailHBOL.vue?vue&type=template&id=4dfb3d18&"
import script from "./ISFDetailHBOL.vue?vue&type=script&lang=js&"
export * from "./ISFDetailHBOL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports